import React, { useEffect, useState } from 'react'
import companyLogo from '../Images/online-adda-logo.png';
import CartCard from '../Components/CartCard';
import { AppContext } from '../App';
import { useContext } from 'react';
import { useLayoutEffect } from 'react';
import CartLogo from '../Images/cart-icon-28356.png'



const CartPage = (props) => {

  
  

  const { data } = props;

  const [cart, setCart] = useContext(AppContext);

  const _cart = { ...cart };
  const AllItemsInCart = { ...cart.items };
  const All = [
    { 1: 200 },
    { 2: 100 },
    { 3: 400 }
  ];

  // const [totalPrice,setTotalPrice]=useState(0);

  // useEffect(()=>{


  //   let sum=0;
  //   for(let key in _cart.items)
  //   {
  //       const pro = data.filter((p)=> p.id==key);
  //       sum+=(Number(pro[0].price)*Number(_cart.items[key]));
  //       console.log("first")
  //       console.log(sum);
  //   }

  //   setTotalPrice(sum);
    

  // },[]);

  if (_cart.itemsCount == 0) {
    return (<div className='w-full h-fit bg-violet-100 md:pt-10 pt-5 pb-10'>
      <div className=' w-fit flex flex-row mx-auto bg-[#35185A]  select-none  justify-center items-center'>
                    <img src={companyLogo} className='md:w-[250px]  w-[200px] select-none  ' />
                    <span className='font-bold md:text-6xl text-2xl md:mt-3 mt-1 -ml-2 text-center pr-5 text-white'>Cart</span>
                </div>
      <div className='flex justify-center items-center w-full min-h-[60vh]'>
            <div className='flex flex-col gap-2'>
              <img className='w-[50px]' src={CartLogo} alt='cart logo'/>
              <span className=''>Empty !</span>
            </div>
        
      </div></div>);
  }
  else
    console.log(AllItemsInCart);



  function decrementCount(idNo) {
    const _cart = { ...cart };
    _cart.itemsCount--;

    if(_cart.itemsCount==0)
    {
      _cart.totalPrice=0;
      console.log("Over")
      _cart.items={};
      setCart(_cart);
      return;
    }

    _cart.items[idNo]--;

    // let sum=totalPrice;
    const pro = data.filter((p)=> p.id==idNo);
        _cart.totalPrice-=(Number(pro[0].price));
    // setTotalPrice(sum);

    if (_cart.items[idNo] == 0) {
      for (let key in _cart.items) {
        if (key == idNo) {
          delete _cart.items[key];
        }
      }
    }
    else {
      _cart.idNo = _cart.idNo - 1;
    }

    console.log(idNo);


    setCart(_cart);
  }

  function incrementCount(idNo) {
    const _cart = { ...cart };
    _cart.itemsCount++;
    _cart.items[idNo]++;

    // let sum=totalPrice;
    const pro = data.filter((p)=> p.id==idNo);
        _cart.totalPrice+=(Number(pro[0].price));
    // setTotalPrice(sum);

    setCart(_cart);
  }

  return (
    <div >

      <div className="w-full h-fit min-h-[70vh]  bg-violet-100 md:pt-10  pt-5 overflow-x-hidden pb-10">

        <div className="container   md:container max-w-[95%] md:max-w-[90%] mx-auto ">

        <div className=' w-fit flex flex-row mx-auto bg-[#35185A]  select-none  justify-center items-center'>
                    <img src={companyLogo} className='md:w-[250px]  w-[200px] select-none  ' />
                    <span className='font-bold md:text-6xl text-2xl md:mt-3 mt-1 -ml-2 text-center pr-5 text-white'>Cart</span>
                </div>

          <div className='flex flex-col  md:gap-6 gap-2  md:mt-10 mt-5'>
            {/* Render the Cart Cards */}
            {
              Object.keys(cart.items).map((oneKey, i) => {
                return (
                  <CartCard decrementCount={decrementCount} incrementCount={incrementCount} cart={cart} setCart={setCart} AllProducts={data} idNo={oneKey} count={AllItemsInCart[oneKey]} />
                )
              })
            }
          </div>

            {/* total Price */}
          <div className='w-full flex justify-end h-[40px] md:h-[100px] mt-5 '>
            <div className='h-full w-full md:w-fit flex md:justify-end justify-between border-[3px] border-violet-500 rounded-lg shadow-xl bg-white'>
                <div className='w-fit mx-3 md:w-[200px] h-full  flex justify-center items-center'>
                  <span className='md:text-3xl text-xl font-bold'>Total</span>
                </div>
                <div className='w-fit md:w-[250px] h-full  flex justify-center items-center lg:ml-7'>
                  <span className='md:text-3xl text-xl font-bold'>{cart.itemsCount}</span>
                </div>
                <div className='w-fit md:w-[200px] h-full flex justify-center items-center p-3 lg:ml-7'>
                  <h1 className='md:text-4xl text-xl text-green-700 font-bold'>₹ {cart.totalPrice.toFixed(2)}</h1>
                </div>
            </div>
          </div>

          <div className=' conatiner md:h-[50px] h-[30px] flex md:justify-end justify-center items-center md:mt-10 mt-5'>
            <button className='select-none md:p-10 p-5 h-full md:text-4xl text-xl bg-violet-800 text-white rounded-xl flex justify-center items-center hover:bg-violet-900 shadow-2xl 
            active:shadow-sm active:text-gray-100'>Buy Now</button>
          </div>

        </div>

      </div>
    </div>
  )
}

export default CartPage